module.exports = __webpack_public_path__ + "static/media/payment-methods.6287736b.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Signup/payment-methods.png
// module id = 2788
// module chunks = 0